import { combineReducers, Middleware } from 'redux';
import ApiReducers from './api/reducers';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import AuthReducer from './auth/reducers';
import { thunk } from 'redux-thunk';
import { configureStore } from '@reduxjs/toolkit';
import type { Action, Reducer, Store } from 'redux';
import type { PersistConfig, PersistState } from 'redux-persist';
import { PersistorOptions } from 'redux-persist';
import { Persistor } from 'redux-persist';
import { GeneralAppReducer } from './page/reducers';


declare module 'redux-persist' {
  export function persistReducer<S, A extends Action = Action, P = S>(
    config: PersistConfig<S>,
    baseReducer: Reducer<S, A, P>,
  ): Reducer<
    S & { _persist: PersistState },
    A,
    P & { _persist?: PersistState }
  >;
  export function persistStore<S = any, A extends Action<any> = Action>(store: Store<S, A>, persistorOptions?: PersistorOptions | null, callback?: () => any): Persistor;
}


//combine reducers in one
const rootReducers = combineReducers({
  auth: AuthReducer,
  page: GeneralAppReducer,
  apis: ApiReducers,
});

//global state of the store
export type AppState = ReturnType<typeof rootReducers>;
const persistenceConfiguration: PersistConfig<AppState> = {
  key: 'store',
  storage: storage,
  blacklist: ['apis', 'page']
};

const persistedReducer = persistReducer(persistenceConfiguration, rootReducers)

export default function ConfigureStore() {

  const middlewares: Middleware[] = [thunk];

  let store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['persist/PERSIST'],
        },
      }).concat(middlewares),
  });

  let persistor = persistStore(store);

  return { store, persistor };
}
